import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".js-philosophy").forEach((el) => {
	let bg = el.querySelector(".js-bg");

	ScrollTrigger.create({
		trigger: el,
		start: "top bottom",
		scrub: true,
		end: "bottom top",
		animation: gsap.fromTo(bg, { y: "-3rem" }, { y: "3rem" }),
	});

	initOnScrollAnimation(el);
});
